
    import __i18nConfig from '@next-translate-root/i18n.js'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    import { NextSeo } from "@components/seo";
import { getAllPosts } from "@utils/get-posts";
import type { GetStaticProps } from "next";
import Image from "next/image";
import Link from "next/link";
// import useTranslation from "next-translate/useTranslation";
import type { TPost } from "../../types/posts";
interface IPost {
    posts: TPost[];
}
const STRIP_HTML_REGEX = /(&nbsp;|&#8211;|(<([^>]+)>))/gi;
const WHITESPACE_REGEX = /\s+/;
const News = ({ posts }: IPost) => {
    // const { lang } = useTranslation("common");
    return (<>
      <NextSeo languageAlternates={[
            { href: "https://knsokna.pl/news", hrefLang: "x-default" },
            { href: "https://knswindows.com/news", hrefLang: "en" },
            { href: "https://knsokna.pl/news", hrefLang: "pl" },
            { href: "https://knsfenster.de/news", hrefLang: "de" },
            { href: "https://kns-okna.eu/news", hrefLang: "cs" },
            { href: "https://knsfinestre.it/news", hrefLang: "it" },
            { href: "https://knsfenetres.fr/news", hrefLang: "fr" },
            { href: "https://knsokna.eu/news", hrefLang: "hu" },
        ]}/>
      <div className="mx-auto flex max-w-7xl flex-wrap justify-center px-4 py-12 sm:px-6 lg:px-8 lg:py-8">
        {Array.isArray(posts)
            ? posts.map((post) => {
                const publishedDate = new Date(post.date).toLocaleString("pl-PL");
                const descriptionAll = post.content.replace(STRIP_HTML_REGEX, "");
                const description = descriptionAll
                    .split(WHITESPACE_REGEX)
                    .slice(0, 20)
                    .join(" ");
                return (<div className="m-2 min-h-full max-w-sm rounded-lg border border-gray-200 bg-white shadow-md dark:border-gray-700 dark:bg-gray-800" key={post.databaseId}>
                  <Image alt="about" className="rounded-t-lg" height="500" src={post.featuredImage?.node.sourceUrl} width="954"/>
                  <time className="pl-5 text-sm text-white">
                    {publishedDate}
                  </time>
                  <div className="p-5">
                    <Link href={`news/${post.slug}`}>
                      <h5 className="mb-2 font-bold text-2xl text-gray-900 tracking-tight dark:text-white">
                        {post?.title}
                      </h5>
                    </Link>
                    <p className="mb-3 font-normal text-gray-700 dark:text-gray-400">
                      {description} ...
                    </p>
                    <a className="inline-flex items-center rounded-lg bg-blue-700 px-3 py-2 text-center font-medium text-sm text-white hover:bg-blue-800 focus:outline-none focus:ring-4 focus:ring-blue-300 dark:bg-blue-600 dark:focus:ring-blue-800 dark:hover:bg-blue-700" href={`news/${post.slug}`}>
                      Czytaj więcej
                      <svg aria-hidden="true" className="-mr-1 ml-2 h-4 w-4" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
                        <path clipRule="evenodd" d="M10.293 3.293a1 1 0 011.414 0l6 6a1 1 0 010 1.414l-6 6a1 1 0 01-1.414-1.414L14.586 11H3a1 1 0 110-2h11.586l-4.293-4.293a1 1 0 010-1.414z" fillRule="evenodd"/>
                      </svg>
                    </a>
                  </div>
                </div>);
            })
            : null}
      </div>
    </>);
};
const getStaticProps: GetStaticProps = async (context) => {
    const locale = context.locale || "PL";
    const language = locale === "cz" ? "CS" : locale.toUpperCase();
    const { allPosts } = await getAllPosts(language, 999);
    const posts = allPosts?.posts?.nodes ?? [];
    return {
        props: {
            posts,
        },
    };
};
export default News;

    async function __Next_Translate__getStaticProps__1a1a83a946d__(ctx) {
      if (typeof global !== 'undefined') {
        global.i18nConfig = __i18nConfig
      }
      const res = await getStaticProps(ctx)
      return {
        
        ...res,
        props: {
          ...(res.props || {}),
          ...(await __loadNamespaces({
            ...ctx,
            ...__i18nConfig,
            pathname: '/news/index',
            loaderName: 'getStaticProps',
            loadLocaleFrom: __i18nConfig && __i18nConfig.loadLocaleFrom || ((l, n) => import('../../locales/' + l + '/' + n).then(m => m.default)),
          }))
        }
      }
    }
    export { __Next_Translate__getStaticProps__1a1a83a946d__ as getStaticProps }
  